export default [
    {
        code: 'agent',
        name: 'Agent Pipeline',
    },
    {
        code: 'buckets',
        name: 'Buckets',
    },
    {
        code: 'inventory',
        name: 'Inventory',
    },
    {
        code: 'escrow',
        name: 'Escrow Tracking',
    },
    {
        code: 'pipeline',
        name: 'Pipeline',
    },
    {
        code: 'fees',
        name: 'SUMMIT Fees',
    }
]